import { QueryObserverOptions, UseQueryResult, useQuery } from '@tanstack/react-query';
import { SelfServiceBooking } from '@jucy/rentals-api-client/rentals-api-v3/models';
import { reservationDataQueryKeys } from '../services/queryKeys';
import { RentalSelfServiceApiClient } from '../services/rentalSelfServiceApiClient';
import { useAuthenticatedSelfServiceApi } from './useAuthenticatedSelfServiceApi';

export type UseGetBookingOptions = Omit<QueryObserverOptions<SelfServiceBooking, Response>, 'queryKey' | 'queryFn'>;
export type UseGetBookingResult = UseQueryResult<SelfServiceBooking, Response>;
export const useGetBooking = (reservationReference?: string, options?: UseGetBookingOptions): UseGetBookingResult => {
    const rentalApiClient = useAuthenticatedSelfServiceApi() as RentalSelfServiceApiClient;
    return useQuery<SelfServiceBooking, Response>({
        queryKey: reservationDataQueryKeys.booking(reservationReference),
        queryFn: async () => await rentalApiClient?.v3.getSelfServiceBooking(reservationReference as string),
        ...options,
        refetchOnWindowFocus: options?.refetchOnWindowFocus === undefined ? false : options.refetchOnWindowFocus,
        retry: options?.retry === undefined ? 0 : options.retry,
        enabled: options?.enabled !== false && Boolean(reservationReference && rentalApiClient?.getReservation),
        staleTime: options?.staleTime === undefined ? 60 * 1000 : options.staleTime,
    });
};
